// Tap In Mock Data - Exact content from Figma mockups

// Brand Assets - ACTUAL logos from user
export const brandAssets = {
  logo: '/brand/tap-in-logo.png', // Official TAP IN logo (blue circle with text)
  fingerprint: 'https://customer-assets.emergentagent.com/job_1986475c-b426-43c8-877c-14f811ca84d9/artifacts/faivw91c_image%20%281%29%201.svg', // SVG fingerprint for tap in actions - CRISP
  appCover: 'https://customer-assets.emergentagent.com/job_phoneauth-app/artifacts/i77sfzrb_2.png', // App icon for link sharing - PROVIDED IMAGE
  defaultSessionGradient: 'https://customer-assets.emergentagent.com/job_phoneauth-app/artifacts/ufg5locs_4.png', // Default gradient background for sessions
  defaultPlaylistPurple: null, // Purple gradient for playlists (generated via CSS)
  honorCultureAd: 'https://customer-assets.emergentagent.com/job_autoplayqueue/artifacts/wais1bn0_Screenshot%202026-01-21%20at%202.39.18%E2%80%AFAM.png', // Honor Culture ad image - BLACK & WHITE VERSION
  appName: 'Tap In',
};

// Theme colors from Figma design
export const themeColors = {
  // Primary gradients
  hostSession: ['#3B82F6', '#60A5FA'], // Blue gradient
  joinSession: ['#8B5CF6', '#A78BFA'], // Purple gradient
  // UI colors
  primaryPurple: '#8F00FF',
  primaryBlue: '#5700FF',
  accentOrange: '#F97316', // Fire/flame color
  lavenderBg: '#E0D9FF',
  lavenderLight: '#F0F0FF',
};

// Mock users from Figma mockups - EXACT names and styling
export const mockUsers = [
  {
    id: 'user_22wvy',
    username: '22WVY',
    displayName: '22WVY',
    profileImage: 'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=150&h=150&fit=crop&crop=face',
    isHost: true,
    isVerified: true,
  },
  {
    id: 'user_rose',
    username: 'Rose',
    displayName: 'Rose',
    profileImage: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&crop=face',
  },
  {
    id: 'user_drew',
    username: 'Drew',
    displayName: 'Drew',
    profileImage: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
  },
  {
    id: 'user_isaiah',
    username: 'Isaiah',
    displayName: 'Isaiah',
    profileImage: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop&crop=face',
  },
  {
    id: 'user_amber',
    username: 'Amber',
    displayName: 'Amber',
    profileImage: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face',
  },
  {
    id: 'user_kahdijah',
    username: 'kahdijah',
    displayName: 'Kahdijah',
    profileImage: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=150&h=150&fit=crop&crop=face',
  },
  {
    id: 'user_focus3dots',
    username: 'Focus3Dots',
    displayName: 'Focus3Dots',
    profileImage: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face',
  },
];

// Mock songs from Figma - EXACT content
export const mockSongs = [
  {
    id: 'song_encore',
    title: 'Encore',
    artist: '22WVY',
    album: 'WVY WRLD',
    artwork_url: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&h=300&fit=crop',
    duration_ms: 179000, // 2:59
  },
  {
    id: 'song_sapphire',
    title: 'Sapphire',
    artist: 'Ed Sheeran',
    album: '=',
    artwork_url: 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=300&h=300&fit=crop',
    duration_ms: 192000, // 3:12
  },
  {
    id: 'song_deepwater',
    title: 'Deep Water',
    artist: 'Dr. Dre',
    album: 'Focus',
    artwork_url: 'https://images.unsplash.com/photo-1571330735066-03aaa9429d89?w=300&h=300&fit=crop',
    duration_ms: 311000, // 05:11
  },
  {
    id: 'song_yes',
    title: 'Yes',
    artist: 'Beyoncé',
    album: 'Focus',
    artwork_url: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&h=300&fit=crop',
    duration_ms: 245000, // 4:05
  },
  {
    id: 'song_hardknocks',
    title: 'Hard Knocks',
    artist: 'Snoop Dogg & Dr. Dre',
    album: 'Focus',
    artwork_url: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=300&h=300&fit=crop',
    duration_ms: 268000, // 4:28
  },
  {
    id: 'song_havana',
    title: 'Havana',
    artist: 'Camila Cabello',
    album: 'Camila',
    artwork_url: 'https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?w=300&h=300&fit=crop',
    duration_ms: 228000, // 3:48
  },
  {
    id: 'song_blindinglights',
    title: 'Blinding Lights',
    artist: 'The Weeknd',
    album: 'After Hours',
    artwork_url: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=300&h=300&fit=crop',
    duration_ms: 200000, // 3:20
  },
  {
    id: 'song_levitating',
    title: 'Levitating',
    artist: 'Dua Lipa',
    album: 'Future Nostalgia',
    artwork_url: 'https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=300&h=300&fit=crop',
    duration_ms: 203000, // 3:23
  },
];

// Mock sessions for demo
export const mockSessions = [
  {
    id: 'session-1',
    title: "Late Night Vibes",
    host: {
      id: 'host-1',
      username: 'jordan_m',
      displayName: 'Jordan',
      profileImage: 'https://images.pexels.com/photos/8112621/pexels-photo-8112621.jpeg?auto=compress&cs=tinysrgb&w=150'
    },
    coverImage: 'https://images.pexels.com/photos/5003397/pexels-photo-5003397.jpeg?auto=compress&cs=tinysrgb&w=300',
    isActive: true,
    isPublic: true,
    guests: [],
    queue: [{ id: 1, title: 'HUMBLE.', artist: 'Kendrick Lamar', artwork_url: 'https://images.pexels.com/photos/5003397/pexels-photo-5003397.jpeg?auto=compress&cs=tinysrgb&w=150' }],
    currentTrackIndex: 0,
    currentTime: 45,
    listenerCount: 12,
    fireCount: 89,
    mode: 'normal'
  },
  {
    id: 'session-2',
    title: "Chill Mode",
    host: {
      id: 'host-2',
      username: 'alex_beats',
      displayName: 'Alex',
      profileImage: 'https://images.pexels.com/photos/8119457/pexels-photo-8119457.jpeg?auto=compress&cs=tinysrgb&w=150'
    },
    coverImage: 'https://images.pexels.com/photos/28248771/pexels-photo-28248771.png?auto=compress&cs=tinysrgb&w=300',
    isActive: true,
    isPublic: true,
    guests: [],
    queue: [{ id: 2, title: 'Blinding Lights', artist: 'The Weeknd' }],
    currentTrackIndex: 0,
    currentTime: 120,
    listenerCount: 28,
    fireCount: 156,
    mode: 'normal'
  },
  {
    id: 'session-3',
    title: "Road Trip Mix",
    host: {
      id: 'host-3',
      username: 'maya_music',
      displayName: 'Maya',
      profileImage: null
    },
    coverImage: 'https://images.pexels.com/photos/196652/pexels-photo-196652.jpeg?auto=compress&cs=tinysrgb&w=300',
    isActive: true,
    isPublic: false,
    guests: [],
    queue: [{ id: 3, title: 'Levitating', artist: 'Dua Lipa' }],
    currentTrackIndex: 0,
    currentTime: 60,
    listenerCount: 5,
    fireCount: 34,
    mode: 'normal'
  }
];

// Mock playlists for demo
export const mockPlaylists = [
  {
    id: 'playlist-1',
    title: 'Summer Hits 2026',
    coverImage: 'https://images.pexels.com/photos/3122799/pexels-photo-3122799.jpeg?auto=compress&cs=tinysrgb&w=300',
    songCount: 24,
    fireCount: 156
  },
  {
    id: 'playlist-2',
    title: 'Workout Beats',
    coverImage: 'https://images.pexels.com/photos/5003397/pexels-photo-5003397.jpeg?auto=compress&cs=tinysrgb&w=300',
    songCount: 18,
    fireCount: 89
  },
  {
    id: 'playlist-3',
    title: 'Chill Lofi',
    coverImage: null,
    songCount: 32,
    fireCount: 234
  }
];

// Trending items for horizontal scroll - EMPTY for fresh testing
export const mockTrending = [];

// Feature descriptions from Figma
export const features = {
  sessions: {
    title: 'Sessions',
    headline: 'Effortless shared listening',
    description: 'Host or join a session where everyone hears the same music, at the same time. Only one device is required to connect to a speaker.',
  },
  playlists: {
    title: 'Playlists',
    headline: 'Curate and share',
    description: 'Create playlists that capture moments. Share with friends and let them tap in.',
  },
};

// Session types from Figma
export const sessionTypes = [
  { id: 'listening', label: 'Listening Parties', icon: 'headphones' },
  { id: 'longdistance', label: 'Long Distance', icon: 'globe' },
  { id: 'study', label: 'Study Sessions', icon: 'book' },
  { id: 'pregame', label: 'Pregame', icon: 'party' },
];

// Navigation items
export const navigationItems = [
  { name: "Home", path: "/" },
  { name: "Sessions", path: "/sessions" },
  { name: "Playlists", path: "/playlists" },
  { name: "Partners", path: "/partners" },
  { name: "Pricing", path: "/pricing" },
  { name: "FAQ", path: "/faq" }
];

// Social links
export const socialLinks = {
  instagram: 'https://instagram.com/tapinsound',
  linkedin: 'https://linkedin.com/company/tapinsound',
  tiktok: '#',
};

// App store links
export const appStoreLinks = {
  apple: '#',
  google: '#',
};
